module.exports = __webpack_public_path__ + "static/img/map.8256330.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map.jpg
// module id = 168
// module chunks = 1